import getIn from 'transmute/getIn';
export const getCount = getIn(['totalCount']);
export const getOffsetTimestamp = getIn(['pagedResult', 'offset', 'offsetTimestamp']);
export const getOffsetId = getIn(['pagedResult', 'offset', 'offsetId']);
export const getHasMore = getIn(['pagedResult', 'hasMore']);
export const getResults = getIn(['pagedResult', 'results']);